import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import ChatView from '../components/ChatView';
import api from '../lib/api';

export default function Chat() {
  const [adminInfo, setAdminInfo] = useState(null);

  useEffect(() => {
    let cancel = false;
    api.get('/admin/info').then(({ data }) => {
      if (!cancel) setAdminInfo(data);
    }).catch(() => {
      // Fallback so the page still renders if the endpoint fails
      if (!cancel) setAdminInfo({ id: null, username: 'Assistenza Golden TV', is_online: true });
    });
    return () => { cancel = true; };
  }, []);

  return (
    <Layout title="Assistenza" showBack backTo="/home">
      {adminInfo && (
        <ChatView
          recipientId={adminInfo.id}
          recipientName={adminInfo.username || 'Assistenza Golden TV'}
          recipientOnline={adminInfo.is_online}
          recipientLastSeen={adminInfo.last_seen}
          recipientAvatarUrl={adminInfo.avatar_url}
        />
      )}
    </Layout>
  );
}
